import axios from '../utils/axios';

export default function fetchCompetitionData(adminId, params) {
    
    return (
        axios.get('/admin/'+adminId + '/competition/user/admin/competition-listing', { params })
    )
}
